import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredQualityApprovals, selectQualityApprovalLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { fetchQualityApprovalData } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as qualityApprovalActions } from './store/slice';

const { setSelectedPart } = qualityApprovalActions;

const { QUALITYAPPROVAL_ADD_EDIT } = MODAL_TYPES;

const QualityApprovalTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredQualityApprovals(state),
    isLoading: selectQualityApprovalLoading(state),
  }));

  const handleEditClick = (e, record) => {
    e.stopPropagation();
    dispatch(fetchQualityApprovalData(record));
    dispatch(setSelectedPart(record));
  };

  const handleDeleteClick = id => {
    // dispatch(deleteQualityApprovals(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Part ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: 'Part Number',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      sorter: (a, b) => a.qualityApproval.length - b.qualityApproval.length,
    },

    {
      title: 'Actions',
      dataIndex: 'qualityApprovalId',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <Link className="me-2 p-2" onClick={e => handleEditClick(e, record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.qualityApprovalId)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default QualityApprovalTable;
